import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function UploadOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_245)'>
        <path
          d='M5 6L19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4L5 4C4.44771 4 4 4.44772 4 5C4 5.55228 4.44771 6 5 6Z'
          fill={color}
        />
        <path
          d='M20 7V5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7Z'
          fill={color}
        />
        <path
          d='M6 7V5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5V7C4 7.55228 4.44772 8 5 8C5.55228 8 6 7.55228 6 7Z'
          fill={color}
        />
        <path
          d='M8 14C7.84476 14 7.69164 13.9638 7.55279 13.8944C7.41393 13.825 7.29315 13.7242 7.2 13.6C7.12121 13.4949 7.06388 13.3754 7.03129 13.2482C6.99869 13.1209 6.99148 12.9886 7.01005 12.8586C7.02862 12.7286 7.07262 12.6035 7.13953 12.4905C7.20643 12.3775 7.29494 12.2788 7.4 12.2L11.4 9.19998C11.5713 9.07483 11.7779 9.00739 11.99 9.00739C12.2021 9.00739 12.4087 9.07483 12.58 9.19998L16.58 12.02C16.7956 12.1729 16.9419 12.405 16.9868 12.6655C17.0318 12.9259 16.9718 13.1936 16.82 13.41C16.7442 13.5181 16.6478 13.6102 16.5362 13.6809C16.4246 13.7515 16.3002 13.7994 16.17 13.8217C16.0399 13.8441 15.9066 13.8404 15.7778 13.8109C15.6491 13.7814 15.5275 13.7267 15.42 13.65L12 11.24L8.6 13.8C8.4269 13.9298 8.21637 14 8 14Z'
          fill={color}
        />
        <path
          d='M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_245'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
